import request from './request';

export const api = {
	getDataList(id, data) {
		let obj = ''
		Object.keys(data).forEach((item, index) => {
			if ((index + 1) == Object.keys(data).length) {
				obj += item + '=' + data[item]
			} else {
				obj += item + '=' + data[item] + '&'
			}
		})
		return request({
			url: `/api/front/article/list/${id}?${obj}`,
			method: 'get',
		});
	},
	getDataInfo(id) {
		return request({
			url: `/api/front/article/info/${id}`,
			method: 'get',
		});
	},
	submitApplyMember(params) {
		return request({
			url: `/api/front/company/settled/apply`,
			method: 'post',
			data: params
		});
	},
	getCompanys(data) {
		let obj = ''
		Object.keys(data).forEach((item, index) => {
			if ((index + 1) == Object.keys(data).length) {
				obj += item + '=' + data[item]
			} else {
				obj += item + '=' + data[item] + '&'
			}
		})
		return request({
			url: `/api/front/merchant/search/list?${obj}`,
			method: 'post'
		});
	},
	getExhibitions(data) {
		let obj = ''
		Object.keys(data).forEach((item, index) => {
			if ((index + 1) == Object.keys(data).length) {
				obj += item + '=' + data[item]
			} else {
				obj += item + '=' + data[item] + '&'
			}
		})
		return request({
			url: `/api/front/exhibition/list?${obj}`,
			method: 'post'
		});
	},
	getExhibitionDetail(id) {
		return request({
			url: `/api/front/exhibition/detail/${id}`,
			method: 'get'
		});
	},
	getCompanysInfo(id) {
		return request({
			url: `/api/front/merchant/detail/${id}`,
			method: 'get',
		});
	},
	getCompanysSp(data) {
		let obj = ''
		Object.keys(data).forEach((item, index) => {
			if ((index + 1) == Object.keys(data).length) {
				obj += item + '=' + data[item]
			} else {
				obj += item + '=' + data[item] + '&'
			}
		})
		return request({
			url: `/api/front/product/merchant/pro/list?${obj}`,
			method: 'get',
		});
	},
	getCompanysSpInfo(id) {
		return request({
			url: `/api/front/product/detail?id=${id}`,
			method: 'get',
		});
	},
	pv() {
		return request({
			url: `/api/front/index/pv`,
			method: 'get'
		});
	},
	// 记录一次访问（未使用百度统计 API 时，用于自建 PV 累加；可选在首屏或入口调用）
	pvRecord() {
		return request({
			url: `/api/front/index/pv/record`,
			method: 'get'
		});
	}
};